import { GenIcon } from '../helpers/IconBase.es.js';

const ArrowDownTinyFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M18.8747 7.5H5.12475C5.01092 7.50004 4.89927 7.52494 4.80184 7.57203C4.70441 7.61911 4.6249 7.68659 4.5719 7.76718C4.51889 7.84777 4.4944 7.93841 4.50107 8.02932C4.50774 8.12023 4.54532 8.20795 4.60975 8.28303L11.4847 16.2833C11.5422 16.3501 11.6191 16.4048 11.7088 16.4425C11.7985 16.4803 11.8984 16.5 11.9997 16.5C12.1011 16.5 12.201 16.4803 12.2907 16.4425C12.3804 16.4048 12.4573 16.3501 12.5147 16.2833L19.3897 8.28303C19.4542 8.20795 19.4917 8.12023 19.4984 8.02932C19.5051 7.93841 19.4806 7.84777 19.4276 7.76718C19.3746 7.68659 19.2951 7.61911 19.1977 7.57203C19.1002 7.52494 18.9886 7.50004 18.8747 7.5Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "15",
                  height: "15",
                  fill: "white",
                  transform: "translate(4.5 4.5)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { ArrowDownTinyFilled };
